import { createActions } from 'redux-actions';

import customerActions from './customer/customerActions';
import giftVoucherActions from './giftVoucher/giftVoucherActions';
import notificationActions from './notifications/notificationActions';
import storage from '@synergycms_core/utils/storage';
import ParamsParser from '@synergycms_core/utils/paramsParser';
import { Map } from 'immutable';
import { contains, pipe, map, sortBy, is } from 'ramda';
import { langCodeCorrector } from '@synergycms_core/utils/api';

//ACTIONS
export default createActions({
  APP: {
    LOAD: (status) => {
      return !!status;
    },
    URLS: (urls) => {
      return urls;
    }
  },
  CUSTOMER: customerActions,
  ROUTER: {
    // arrayHash -> es el hash actual de la URL del navegador
    UPDATE: (replace = false) => (dispatch, getState, arrayHash) => {
      const store = getState();
      const newHash = [];

      if (contains(newHash[0], ['customerForm', 'confirmation', 'cancelation'])) {
        const reservation = store.getIn(['customer', 'reservation'], Map());
        const trackingId = reservation.get('tracking_id', false);
        newHash[2] = trackingId || '';

        if (
          newHash[0] === 'customerForm' &&
          +newHash[2] > 0 &&
          reservation.getIn(['payment', 'payform_code'], false) === 'op' &&
          arrayHash[3] &&
          arrayHash[3].length > 0 &&
          // de moment només utilitzarem el quart HASH per TPV EPG
          arrayHash[3].indexOf('EPG') !== -1
        ) {
          newHash[3] = arrayHash[3];
        }
      }

      const urlParams = store.getIn(['customer', 'params', 'url_params']);

      let validRoute = {
        hash: newHash,
        search: ParamsParser.convertParamsToStringQuery(urlParams)
      };

      storage.setLocal('last_valid_route', validRoute);

      if (replace) {
        validRoute.action = 'replace';
      }
      return validRoute;
    },
    ERROR: (params = Map()) => (dispatch, getState, arrayHash) => {
      const lastValidRoute = storage.getLocal('last_valid_route');
      if (lastValidRoute) {
        lastValidRoute.action = 'replace';
        return lastValidRoute;
      }
    }
  },
  TPV: {
    GET: (tpvInfo) => {
      return tpvInfo;
    }
  },
  COUNTRIES: {
    GET: (countries, langInfo) => {
      return pipe(
        map(country => {
          let langCode = langInfo.code.toLowerCase() || 'en';
          langCode = langCodeCorrector(langCode);
          let translations = country.translations[langCode];
          country.name =
            translations === undefined || translations.name === undefined
              ? country.translations['en'].name
              : translations.name;
          return country;
        }),
        sortBy(f => f.name)
      )(countries);
    }
  },
  NOTIFICATIONS: notificationActions,
  GIFT_VOUCHER: giftVoucherActions
});
